// Don't remove any comments or any code without the permission of author, wrong commited(pushed) changes may harm to many other pages $$...
// ***********************************
import { Component, ViewChild, OnInit, Input, Output, EventEmitter, OnChanges, AfterViewInit, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import * as moment from 'moment';
import { MatPaginator, MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { clickableColumns } from '../clickableColumns';
import { ExcelServicesService } from '../excel-services.service';
import { editColumnEventDetails } from '../editColumnEventDetails';
import { LoaderService } from '../../shared/loader/loader.service';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';

function CustomPaginator() {
  const customPaginatorIntl = new MatPaginatorIntl();
  customPaginatorIntl.itemsPerPageLabel = 'Records per page:';
  return customPaginatorIntl;
}

export interface ClickableColumnsReference {
  obj: any;                        // this will have data for column of type clickableColumns $$..
  clickable: boolean;              // if true then show this column with icon $$..
}

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  providers: [
    { provide: MatPaginatorIntl, useValue: CustomPaginator() }
  ]
})

export class TableComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() downloadFileName: string;                  // this name will be used to downlaod excel $$....
  @Input() datePipe: string = "ConvertLocalDateOnly"; // this pipe will be applicable on date columns $$....
  @Input() targetList: any[];   
  @Input() modulename: string;                       // being used to get list from parent component $$....
  @Input() clickableColumns: clickableColumns[] = []; // being used to get list of clickable columns and icons $$....
  @Input() totalCount: number;                        // Count of full list, being used in pagination total length $$....
  @Input() pageIndex?: number = 0;                    // Page index can be set from parent component in eg. 1 $$....
  @Input() pageSize: number;                          // Default page size can be set from parent component in eg. 10 $$....
  @Input() displayedColumns: string[];                // being used to set definition of mat-table columns
  @Input() showColumnNames: string[];                 // being used to show columns' label $$....
  @Input() showBadge? = 0;                            // this is optional if 0 will not apply badge if column number then badge will be applied on that particular column 

  @Output() editObject = new EventEmitter();          // will open edit model for selected object/record $$....
  @Output() pageChangeEvent = new EventEmitter();     // will call table data based on selection in paginator $$....
  @Output() exportToExcel = new EventEmitter();       // will download all records of list $$....

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  dataSource: MatTableDataSource<any>;
  filteredList: any[] = [];
  dataCount = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  paginatorTotalLength = 0;
  filterText :any;
  updatedClickableColumns: ClickableColumnsReference[] = [];
  globalSort: Sort;
  value = '';
  
  constructor(
    private excelService: ExcelServicesService,
    private loaderService: LoaderService,
    private cdr: ChangeDetectorRef,
    private _dataSharingService: DataSharingService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hasOwnProperty('targetList')) {
      if(!changes.targetList.firstChange) this.filterText = '';
    }
    if (this.targetList != undefined) {
      this.convertDateProperties();   // this will be applicable on date fields which have been added here in this component $$..  
      this.filteredList = this.targetList.map(s => Object.assign(s));
      this.paginatorTotalLength = this.totalCount;
    }
    this.modulename;
    this.createTargetTable();
    this.paginationAccordingToDataLength();
    this.clickableColumnIfTrue();
    if (this.globalSort) this.onSortData(this.globalSort);
   
    // these are being used to check values in dubugging mode $$..
    this.downloadFileName;
    this.datePipe;
    this.targetList;
    this.clickableColumns;
    this.totalCount;
    this.pageIndex;
    this.pageSize;
    this.displayedColumns;
    this.showColumnNames;
    this.showBadge;

    this.cdr.detectChanges();
  }

  ngOnInit() { }

  convertDateProperties() {
    this.targetList.forEach(obj => {
      if (obj.hasOwnProperty('CreatedOn')) obj["CreatedOnDt"] = dateConvertor(obj.CreatedOn, this.datePipe);
      else if (obj.hasOwnProperty('createdOn')) obj["createdOnDt"] = dateConvertor(obj.createdOn, this.datePipe);
      if (obj.hasOwnProperty('UpdatedOn')) obj["UpdatedOnDt"] = dateConvertor(obj.UpdatedOn, this.datePipe);
      else if (obj.hasOwnProperty('updatedOn')) obj["updatedOnDt"] = dateConvertor(obj.updatedOn, this.datePipe);

      if (obj.hasOwnProperty('RegisterDate')) obj["RegisterDateDt"] = dateConvertor(obj.RegisterDate, this.datePipe);
      else if (obj.hasOwnProperty('registerDate')) obj["registerDateDt"] = dateConvertor(obj.registerDate, this.datePipe);

      if (obj.hasOwnProperty('Callback')) obj["CallbackDt"] = dateConvertor(obj.Callback, this.datePipe);
      else if (obj.hasOwnProperty('callback')) obj["callbackDt"] = dateConvertor(obj.callback, this.datePipe);
      if (obj.hasOwnProperty('DateAdded')) obj["DateAddedDt"] = dateConvertor(obj.DateAdded, this.datePipe);
      else if (obj.hasOwnProperty('dateAdded')) obj["dateAddedDt"] = dateConvertor(obj.dateAdded, this.datePipe);

      if (obj.hasOwnProperty('StartDate')) obj["StartDateDt"] = dateConvertor(obj.StartDate, this.datePipe);
      else if (obj.hasOwnProperty('startDate')) obj["startDateDt"] = dateConvertor(obj.startDate, this.datePipe);
      if (obj.hasOwnProperty('EndDate')) obj["EndDateDt"] = dateConvertor(obj.EndDate, this.datePipe);
      else if (obj.hasOwnProperty('endDate')) obj["endDateDt"] = dateConvertor(obj.endDate, this.datePipe);

      if (obj.hasOwnProperty('LoginAt')) obj["LoginAtDt"] = dateConvertor(obj.LoginAt, this.datePipe);
      else if (obj.hasOwnProperty('loginAt')) obj["loginAtDt"] = dateConvertor(obj.loginAt, this.datePipe);
      if (obj.hasOwnProperty('LogoutAt')) obj["LogoutAtDt"] = dateConvertor(obj.LogoutAt, this.datePipe);
      else if (obj.hasOwnProperty('logoutAt')) obj["logoutAtDt"] = dateConvertor(obj.logoutAt, this.datePipe);

      if (obj.hasOwnProperty('AccessedOn')) obj["AccessedOnDt"] = dateConvertor(obj.AccessedOn, this.datePipe);
      else if (obj.hasOwnProperty('accessedOn')) obj["accessedOnDt"] = dateConvertor(obj.accessedOn, this.datePipe);
    
      if (obj.hasOwnProperty('LastLoginDate')) obj["LastLoginDateDt"] = dateConvertor(obj.LastLoginDate, this.datePipe);
      else if (obj.hasOwnProperty('lastLoginDate')) obj["lastLoginDateDt"] = dateConvertor(obj.lastLoginDate, this.datePipe);
    

      if (obj.hasOwnProperty('Callback')) obj["CallbackDt"] = dateConvertor(obj.Callback, this.datePipe);
      else if (obj.hasOwnProperty('callback')) obj["callbackDt"] = dateConvertor(obj.callback, this.datePipe);
    
      
    });
  }

  greaterThan(name:any,num:number) {
    name =String(name) ;
    return name.length > 25 ? true: false;
  }

  lesssThan(name:any,num:number)
  {
    name =String(name) ;
    return name.length <= 25 ? true: false;
  }

  createTargetTable() {
    this.setTableAfterDataRefresh();
  }

  setTableAfterDataRefresh() {
    this.dataSource = new MatTableDataSource(this.filteredList);
    this.dataCount = this.filteredList.length;
    this.tableSortAndPaginator();
  }

  ngAfterViewInit() {
    this.tableSortAndPaginator();
  }

  tableSortAndPaginator() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  // For setting pagination options to show users $$...
  paginationAccordingToDataLength() {
    const length = this.totalCount;
    switch (true) {
      case (length <= 10): {
        //this.pageSizeOptions = [1, 2, 3, 4, 5, 10];
        this.pageSizeOptions = [5, 10, 25, 50, 100];
        break;
      }
      case (length > 10 && length < 100): {
        this.pageSizeOptions = [5, 10, 25, 50, 100];
        break;
      }
      case (length > 100 && length < 200): {
        this.pageSizeOptions = [5, 10, 25, 50, 100, 200];
        break;
      }
      case (length > 200 && length < 300): {
        this.pageSizeOptions = [5, 10, 25, 50, 100, 200, 300];
        break;
      }
      case (length > 300 && length < 500): {
        this.pageSizeOptions = [5, 10, 25, 50, 100, 200, 300, 500];
        break;
      }
      case (length > 500): {
        this.pageSizeOptions = [5, 10, 25, 50, 100, 200, 300, 500, 1000];
        break;
      }
    }
  }

  clickableColumnIfTrue() {
    if (this.clickableColumns.length > 0) {
      this.displayedColumns.forEach(column => {
        let found = false;
        this.clickableColumns.forEach(clkColumn => {
          if (column === clkColumn.column) {
            this.updatedClickableColumns.push({ obj: clkColumn, clickable: true });
            found = true;
          }
        });
        if (!found) {
          this.updatedClickableColumns.push({ obj: {}, clickable: false });
        }
      });
    }
  }

  // will call data according to selection in paginator $$...
  pageEventPropogate(eventData: PageEvent) {
    this.filterText = '';
    eventData.pageIndex;
    this.pageIndex;
    this.pageChangeEvent.emit(eventData)
  }

  Search(filterValue) {
    this.modulename;
    if(this.modulename=="Module"){
      this._dataSharingService.sendSearchValueForModule(filterValue);     
    }
    if(this.modulename=="Role"){
      this._dataSharingService.sendSearchValueForRole(filterValue);     
    }
    if(this.modulename=="Oraganization"){
      this._dataSharingService.sendSearchValueForOrganization(filterValue);     
    }
    if(this.modulename=="Permission"){
      this._dataSharingService.sendSearchValueForPermission(filterValue);     
    }
    if(this.modulename=="User"){
      this._dataSharingService.sendSearchValueForUser(filterValue);     
    }
  }
  // to filter based on search $$....
  applyFilter(filterValue) {
    // this.modulename;
    // if(this.modulename=="Module"){
    //   this._dataSharingService.sendSearchValueForModule(filterValue);
    //   //return;
    // }
    this.filterText = filterValue.trimLeft();
    let _fullList = this.targetList.map(s => Object.assign(s));
    filterValue = filterValue.trim().toLowerCase();
    if (!filterValue || filterValue == "") {
      this.filteredList = _fullList;
      this.paginatorTotalLength = this.totalCount;
    }
    else {
      //this.dataSource = new MatTableDataSource(_fullList);      // this will be applicable on all columns of list $$..
      //this.dataSource.filter = filterValue;
      //const filtered_list = this.dataSource.filteredData;
      const filtered_list = searchInDynamicTable(filterValue, _fullList, this.displayedColumns, this.clickableColumns);
      this.filteredList = filtered_list;
      this.paginatorTotalLength = this.filteredList.length;
    }
    this.setTableAfterDataRefresh();
  }

  // To open edit model $$....
  clickColumnEvent(columnIndex: number, element: any, functionName?: string) {
    let returnObj: editColumnEventDetails = {
      function: functionName,
      columnIndex: columnIndex,
      data: element
    };
      this.editObject.emit(returnObj);
  }

  // For sorting event on dynamic columns $$....
  onSortData(sort: Sort) {
    this.globalSort = Object.assign(sort);
    const data = this.filteredList.slice();
    if (!sort.active || sort.direction === '') {
      const isAsc = sort.direction === 'desc';
      // Need to have valid updatedOn (not 0) value for applying this $$..
      // if (this.filteredList[0]["updatedOn"] != undefined) this.applySortingByKey('updatedOn', isAsc);
      // else if (this.filteredList[0]["UpdatedOn"] != undefined) this.applySortingByKey('UpdatedOn', isAsc);

      // if (this.filteredList[0]["createdOn"] != undefined) this.applySortingByKey('createdOn', isAsc);
      // else if (this.filteredList[0]["CreatedOn"] != undefined) this.applySortingByKey('CreatedOn', isAsc);

      // this will sort by updated on if not have value then by created on $$..
      // let createdOnKey: string, updatedOnKey: string;
      // if (this.filteredList[0]["createdOn"] != undefined) createdOnKey = 'createdOn';
      // else if (this.filteredList[0]["CreatedOn"] != undefined) createdOnKey = 'CreatedOn';
      // if (this.filteredList[0]["updatedOn"] != undefined) updatedOnKey = 'updatedOn';
      // else if (this.filteredList[0]["UpdatedOn"] != undefined) updatedOnKey = 'UpdatedOn';
      // this.applySortingByCreatedOnUpdatedOn(createdOnKey, updatedOnKey);

      // this has been added so that original sorting can be retained due to missing updatedOn in any record $$..
      this.applyFilter(this.filterText);
    }
    else {
      const isAsc = sort.direction === 'asc';
      this.applySortingByKey(sort.active, isAsc);
    }
    this.setTableAfterDataRefresh();
  }

  // will sort list by key and direction $$....
  applySortingByKey(key: string, isAsc: boolean) {
    const data = this.filteredList.slice();
    this.filteredList = data.sort((a, b) => {
      if (a[key] === b[key]) return;
      if (typeof a[key] == "number") {
        return compare(+a[key], +b[key], isAsc);
      }
      else {
        const val1 = a[key] ? a[key].toUpperCase() : '';
        const val2 = b[key] ? b[key].toUpperCase() : '';
        return compare(val1, val2, isAsc);
      }
    });
  }

  // will sort list by createdOn/updatedOn and desc direction $$....
  applySortingByCreatedOnUpdatedOn(createdOn: string, updatedOn: string) {
    let data = this.filteredList.slice();
    this.filteredList = data.sort((a, b) => {
      if (a[updatedOn] === b[updatedOn]) return;
      if (typeof a[updatedOn] == "number") {
        return compare(+a[updatedOn], +b[updatedOn], false);
      }
    });
    let data2 = this.filteredList.slice();
    this.filteredList = data2.sort((a, b) => {
      if (a[updatedOn] == 0 || a[updatedOn] == null && b[updatedOn] == 0 || b[updatedOn] == null) {
        if (a[createdOn] === b[createdOn]) return;
        if (typeof a[createdOn] == "number" && typeof b[createdOn] == "number") {
          return compare(+a[createdOn], +b[createdOn], false);
        }
      }
      else if (a[updatedOn] == 0 || a[updatedOn] == null && b[updatedOn] != 0 && b[updatedOn] != null) {
        if (a[createdOn] === b[updatedOn]) return;
        if (typeof a[createdOn] == "number" && typeof b[updatedOn] == "number") {
          return compare(+a[createdOn], +b[updatedOn], false);
        }
      }
      else if (a[updatedOn] != 0 && a[updatedOn] != null && b[updatedOn] == 0 || b[updatedOn] == null) {
        if (a[updatedOn] === b[createdOn]) return;
        if (typeof a[updatedOn] == "number" && typeof b[createdOn] == "number") {
          return compare(+a[updatedOn], +b[createdOn], false);
        }
      }
    });
  }

  isDateType(columnName: string): boolean {
    const value = this.filteredList[0][columnName];
    if (!Number.isNaN(Number(value))) return false;
    let date = new Date(value);
    if (date.toString() == "Invalid Date") return false;
    if ((toString.call(date)) == "[object Date]") return true;
    else return false;
  }

  // Will download all records only if list isn't filtered otherwise filtered records  $$...
  exportAsXLSX(): void {
    if (this.filterText.trimRight().trimLeft().length != 0) { this.exportToExcel.emit(); }
    else {
      let list = JSON.parse(JSON.stringify(this.filteredList));
      let tempList = list;
      tempList.forEach(obj => {
        if ("totalCount" in obj) delete obj.totalCount;
        else if ("TotalCount" in obj) delete obj.TotalCount;
      });
      if (tempList.length > 0) {
        let exportList: any[] = downloadableListAsDisplayedColumns(tempList, this.displayedColumns, this.clickableColumns, this.showColumnNames);
        this.excelService.exportAsExcelFile(exportList, this.downloadFileName);
      }
    }
  }
}

// function to return date format $$...
function dateConvertor(value: any, datePipe: string) {
  value =new Date(value);
  if (Number(value) == 0) {
    return "";
  }
  if (datePipe == "ConvertLocalDate") {
    return moment.utc(Number(value)).local().format("MM/DD/YYYY HH:mm:ss").valueOf();
  }
  else {
    return moment.utc(Number(value)).local().format("MM/DD/YYYY").valueOf();
  }
}

// function to apply sorting $$....
export function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

// function to apply searching $$....
function searchInDynamicTable(passedString: string, List: any[], columnNames: string[], clickableColumns: clickableColumns[]) {
  let _columnNames: string[] = removeClickableColumnsFromDisplayedColumns(columnNames, clickableColumns);
  let returnList: any[] = filterListBySearchStringOnDisplayedColumns(passedString, List, _columnNames);
  return returnList;
}

// function to return downloadable list $$....
export function downloadableListAsDisplayedColumns(list: any[], displayedColumns: string[], clickableColumns: clickableColumns[], showColumns: string[], datePipe?: string) {
  let DtPipe: string = datePipe ? datePipe : "ConvertLocalDateOnly";
  let List: any[] = manageListForExactDate(list, displayedColumns, DtPipe);
  let localColumnList: string[] = JSON.parse(JSON.stringify(displayedColumns));
  let removedDtInDateCols: string[] = [];
  localColumnList.filter(s => { if (s.endsWith('Dt')) s = s.substring(0, s.length - 2); removedDtInDateCols.push(s); });
  let columns = removeClickableColumnsFromDisplayedColumns(removedDtInDateCols, clickableColumns);
  let downloadableList: any[] = removeColumnsInListIfNotInDisplayedColumns(List, columns);
  let replacedColsDownloadList: any[] = replaceColumnsWithDisplayedColumns(downloadableList, columns, removedDtInDateCols, showColumns);
  return replacedColsDownloadList;
}

export function manageListForExactDate(List: any[], displayedColumns: string[], DtPipe: string) {
  let managedDateList: any[] = List.map(s=>Object.assign(s));
  let localColumnList: string[] = JSON.parse(JSON.stringify(displayedColumns));
  localColumnList.forEach(s => { 
    if (s.endsWith('Dt')) {
      let propWithoutDt = s.substring(0, s.length - 2);
      managedDateList.forEach(ss=>{
        ss[propWithoutDt] = dateConvertor(ss[propWithoutDt], DtPipe)
      });
    } 
  });
  return managedDateList;
}

// will change column name as it is being shown in table for excel download $$..
function replaceColumnsWithDisplayedColumns(List: any[], properties: string[], removedDtDisplayedColumns: string[], showColumnNames: string[]) {
  let tempList: any[] = List.map(s => Object.assign({}, s));
  let tableColumns: string[] = [];      // columns of table without clickable columns $$..
  properties.forEach(s => {
    let index: number = removedDtDisplayedColumns.indexOf(s);
    let col: string = showColumnNames[index];
    tableColumns.push(col);
  });
  
  tempList.forEach(s => {
    for(let i = 0; i < tableColumns.length; i++){
      if (s[tableColumns[i]] == s[properties[i]]){
       // tableColumns[i] = tableColumns[i] + " ";
      }
      s[tableColumns[i]] = s[properties[i]];
        delete s[properties[i]];
    }
  });
  return tempList;
}

// will remove clickable columns from targetting columns $$..
function removeClickableColumnsFromDisplayedColumns(displayedColumns: string[], clickableColumns: clickableColumns[]) {
  let displayedColumnsLocal: string[] = JSON.parse(JSON.stringify(displayedColumns));
  if (clickableColumns.length > 0) {
    clickableColumns.forEach(clickable => {
      displayedColumnsLocal.forEach(column => {
        if (clickable.column == column)
          displayedColumnsLocal.splice(displayedColumnsLocal.indexOf(column), 1);
      });
    });
  }
  return displayedColumnsLocal;
}

// Will filter in available columns only $$..
function filterListBySearchStringOnDisplayedColumns(searchString: string, targetList: any[], targetColumns: string[]) {
  let searchedList: any[] = [];
  let _targetList: any[] = targetList.map(s => Object.assign({}, s));
  for (var i = 0; i < _targetList.length; i++) {
    for (var j = 0; j < targetColumns.length; j++) {
      let obj = _targetList[i];
      let column = targetColumns[j];
      let val = obj[column];
      let value = val ? val.toString().toLowerCase() : '';
      let found = value.includes(searchString);
      if (found) {
        searchedList.push(_targetList[i]);
        break;
      }
    }
  }
  return searchedList;
}

// will remove those columns which are not being shown to users in the table $$..
function removeColumnsInListIfNotInDisplayedColumns(targetList: any[], diplayedColumns: string[]) {
  let columnRemovedList: any[] = targetList.map(s => Object.assign({}, s));
  for (var propt in targetList[0]) {
    let found = false;
    for (var j = 0; j < diplayedColumns.length; j++) {
      if (diplayedColumns[j] == propt) {
        found = true;
        break;
      }
    }
    if (!found) {
      columnRemovedList.forEach(element => {
        delete element[propt];
      });
    }
  }
  return columnRemovedList;
}


// Global function to remove special character at last of the string if exists $$...
export function checkSpecialCharactorAtLastAndRemove(returnClearString: string) {
  let format = /^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/;
  let Charactor: string = returnClearString.charAt(returnClearString.length-1);
  returnClearString = Charactor.match(format) ? returnClearString.substring(0, returnClearString.length-2) : returnClearString;
  return returnClearString;
}


// Global function to sort list by column name $$..
export function getSortedListByColumn(list: any[], column: string) {
  if (list == null || list == undefined) return list;
  let unsortedList: any[] = list.map(s=>Object.assign(s));
  const SortedList = unsortedList.sort((a, b) => {
    const value1 = a[column] ? a[column].toLowerCase() : "";
    const value2 = b[column] ? b[column].toLowerCase() : "";
    let returnValue = ((value1 > value2) ? 1 : -1 );
    return returnValue ? returnValue : 0;
  });
  return SortedList;
}


